<template>
    <v-btn icon
        variant="text"
        size="normal"
        class="exitBtn">
        <v-icon
            color="red">
            mdi-close
        </v-icon>
    </v-btn>
</template>

<style scoped>

.exit-button {
  background: transparent;
  box-shadow: none;
}

</style>